import { CATEGORY_NAME, DESCRIPTION } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { routes } from "@/routes/utils";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";
import { schema } from "./validations";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Property Category",
    moduleRoute: `${routes.masterData}/${routes.propertyCategory}`,
    schema,
    defaultValues: { [CATEGORY_NAME]: "", [DESCRIPTION]: "" },
    nameFieldKey: CATEGORY_NAME,
    queryKeyToInvalidate: "property-categories",
    module: "property-categories",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Category Name"
    />
  );
};

export default AddEdit;
